import { theme } from "antd";

export const colorPrimary = "#fe991c";
export const colorSuccess = "#108c00";
export const colorWarning = "#fe991c";
export const colorError = "#ff4d4f";
export const colorInfo = "#3c89da";
export const colorBlack = "#000";
export const colorWhite = "#fff";

export const colorPink = "#eb2f96";
export const colorPurple = "#800080";

export const colorGray1 = "#ffffff";
export const colorGray2 = "#fafafa";
export const colorGray3 = "#f5f5f5";
export const colorGray4 = "#f0f0f0";
export const colorGray5 = "#d9d9d9";
export const colorGray6 = "#bfbfbf";
export const colorGray7 = "#8c8c8c";
export const colorGray8 = "#595959";
export const colorGray9 = "#434343";
export const colorGray10 = "#262626";
export const colorGray11 = "#1f1f1f";
export const colorGray12 = "#141414";
export const colorGray13 = "#000000";

const antdThemeLight = {
    token: {
        colorPrimary: colorPrimary,
        colorInfo: colorInfo,
        colorWarning: colorWarning,
        colorSuccess: colorSuccess,

        colorTextDescription: colorGray8,

        controlHeight: 38,
        controlHeightLG: 44,
        controlHeightSM: 26,
    },
    components: {
        Layout: {
            siderBg: colorGray2,
            footerBg: colorGray1,
        },
        Menu: {
            iconSize: 18,
        },
    },
};

const antdThemeDark = {
    token: {
        colorPrimary: colorPrimary,
        colorInfo: colorInfo,
        colorWarning: colorWarning,
        colorSuccess: colorSuccess,
        colorBgBase: colorGray11,

        colorTextDescription: colorGray6,

        controlHeight: 38,
        controlHeightLG: 44,
        controlHeightSM: 26,
    },
    algorithm: theme.darkAlgorithm,
    components: {
        Layout: {
            siderBg: colorGray2,
            footerBg: colorGray11,
        },
        Menu: {
            iconSize: 18,
        },
    },
};

const styledThemeLight = {
    theme: "light",

    colorPrimary,
    colorInfo,
    colorWarning,
    colorSuccess,
    colorError,

    colorPink,
    colorPurple,

    colorGray1,
    colorGray2,
    colorGray3,
    colorGray4,
    colorGray5,
    colorGray6,
    colorGray7,
    colorGray8,
    colorGray9,
    colorGray10,
    colorGray11,
    colorGray12,
    colorGray13,
};

const styledThemeDark = {
    theme: "dark",

    colorPrimary,
    colorInfo,
    colorWarning,
    colorSuccess,
    colorError,

    colorPink,
    colorPurple,

    colorGray1: colorGray13,
    colorGray2: colorGray12,
    colorGray3: colorGray11,
    colorGray4: colorGray10,
    colorGray5: colorGray9,
    colorGray6: colorGray8,
    colorGray7: colorGray7,
    colorGray8: colorGray6,
    colorGray9: colorGray5,
    colorGray10: colorGray4,
    colorGray11: colorGray3,
    colorGray12: colorGray2,
    colorGray13: colorGray1,
};

export const antdTheme = {
    light: antdThemeLight,
    dark: antdThemeDark,
};

export const styledTheme = {
    light: styledThemeLight,
    dark: styledThemeDark,
};
